import React, { useCallback } from 'react';
import {
	dismissFlag as createDismissFlag,
	SuccessFlag,
	useFlagService,
} from '@atlassian/jira-flags';
import { RequestAccessSuccessFlag } from '@atlassian/cross-join-nudges';
import { generateId } from '../../utils/index.tsx';

export const useMsrRequestAccessSuccessFlag = () => {
	const { showFlag, dismissFlag } = useFlagService();
	return useCallback(() => {
		const id = `success-${generateId()}`;
		const dismiss = () => dismissFlag(createDismissFlag(id));

		showFlag({
			id,
			render: (props) => (
				<RequestAccessSuccessFlag
					{...props}
					id={id}
					onDismiss={dismiss}
					flagComponent={SuccessFlag}
				/>
			),
		});
	}, [dismissFlag, showFlag]);
};
